import BaseModel from '@/model/BaseModel';

/**
 * @typedef CentralReprocessamentoErroDTO
 * @property {CENTRAL_REPROCESSAMENTO_ERRO_ENUM} codigo
 * @property {string} descricao
 */
export class ModelCentralReprocessamentoErro extends BaseModel {
  constructor() {
    super();
    this.codigo = null;
    this.descricao = null;
  }

  /** @param {CentralReprocessamentoErroDTO} dto */
  static fromObject(dto) {
    const instance = new ModelCentralReprocessamentoErro();
    instance.codigo = dto.codigo;
    instance.descricao = dto.descricao;
    return instance;
  }
}
